import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useNotificationService } from 'src/features/notificationService/useNotificationService'
import { updateTemplateNodeMultipleChoice } from 'src/state/ducks/templates/actions'
import { extractHttpErrorMessages } from 'src/state/middleware/saga/handleHttpError'
import { useTemplateEditMode } from '../../context/TemplateEditMode/TemplateEditMode'
import {
  UpdateTemplateSpecificMultipleChoicesParams,
  useMutationUpdateTemplateSpecificMultipleChoices,
} from '../api/useMutationUpdateTemplateSpecificMultipleChoices'

export const useUpdateTemplateSpecificMultipleChoices = () => {
  const { showNotification } = useNotificationService()
  const dispatch = useDispatch()
  const templateEditMode = useTemplateEditMode()
  const { mutate, isPending } =
    useMutationUpdateTemplateSpecificMultipleChoices(templateEditMode)
  const updateTemplateSpecificMultipleChoices = useCallback(
    (
      params: UpdateTemplateSpecificMultipleChoicesParams,
      onSuccess: () => void,
    ) => {
      mutate(params, {
        onSuccess: updatedChoices => {
          // テンプレートノードの選択肢を更新し、条件分岐の整合性を保つ
          dispatch(updateTemplateNodeMultipleChoice(params.id, updatedChoices))
          onSuccess()
        },
        onError: (e: unknown) => {
          showNotification('選択肢の更新に失敗しました', {
            notificationType: 'error',
            duration: 5,
            description: extractHttpErrorMessages(e),
          })
        },
      })
    },
    [mutate, showNotification, dispatch],
  )
  return {
    updateTemplateSpecificMultipleChoices,
    isPendingUpdateTemplateSpecificMultipleChoices: isPending,
  }
}
